const RecognitionSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M9.00065 2L12.6673 5.66667V13.3333C12.6673 13.7 12.3673 14 12.0007 14H4.00065C3.63398 14 3.33398 13.7 3.33398 13.3333V2.66667C3.33398 2.3 3.63398 2 4.00065 2H9.00065Z"
        stroke="#333333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.88732 10.5533C8.84732 11.5933 7.15398 11.5933 6.11398 10.5533C5.07398 9.51333 5.07398 7.82 6.11398 6.78C7.15398 5.74 8.84732 5.74 9.88732 6.78C10.9273 7.82 10.9273 9.51333 9.88732 10.5533ZM9.88732 10.5533L13.0007 13.6667"
        stroke="#333333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default RecognitionSvg;
